// extracted by mini-css-extract-plugin
export default {"table-wrapper":"LlnlqR5tMVgCC0WHwKt-TQ==","message":"_0sSIjlNSyCQh2GFJAe--hA=="};